import { Component, Input, Output, OnInit, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { EChartOption, ECharts } from 'echarts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { ChartOptionService } from '../../service/chart-option.service';
import { ChartResizeService } from '../../service/chart-resize.service';
import { EventWareService } from './event-ware.service'
import * as _ from 'lodash'
@Component({
  selector: 'bcac-event-wave',
  templateUrl: './event-wave.component.html',
  styleUrls: ['./event-wave.component.scss']
})
export class EventWaveComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private chartOptionService: ChartOptionService,
    private chartResizeService: ChartResizeService,
    private service: EventWareService,
    private cdr: ChangeDetectorRef,
  ) { }


  chartTitle = {
    show: true,
    label: "图表标题"
  };


  initOpts = this.chartOptionService.getInitOpts();

  // 布局设置
  cardPadding = "1rem";
  cardBgColor = "#fff";
  chartTitleColor = '';

  // eachrt图表元素
  chartBackgroundColor: string = "#fff";
  chartColors: string[] = this.chartOptionService.getChartColors("default");
  chartTitles = this.chartOptionService.getChartTitle();
  chartLegend = this.service.getChartLegend();
  chartGrid: EChartOption.Grid = this.commonService.changeFontSize().interval;
  chartxAxis = this.service.getChartxAxis();
  chartyAxis = this.service.getChartyAxis();
  chartSeries: EChartOption.Series = [];
  chartTooltip = this.service.getDefaultTooltip();
  chartToolbox = this.service.getChartToolbox();




  chartOption = {
    backgroundColor: this.chartBackgroundColor,
    color: this.chartColors,
    title: this.chartTitles,
    tooltip: this.chartTooltip,
    legend: this.chartLegend,
    grid: this.chartGrid,
    xAxis: this.chartxAxis,
    yAxis: this.chartyAxis,
    series: this.chartSeries,
    toolbox: this.chartToolbox,
  };

  bcacIsDarkMode: boolean = false
  //接口区
  @Input()
  set bcacDarkMode(darkMode: boolean) {
    const isdarkMode: boolean = typeof (darkMode) == "string"
      ? JSON.parse(darkMode)
      : darkMode;
    if (isdarkMode){
      this.service.changeChartTitleDark(this, darkMode);
      this.service.chartBackgroundColorDarkMode(this.chartOption);
      this.service.xAxisDarkMode(this.chartxAxis);
      this.service.yAxisDarkMode(this.chartyAxis);
      this.service.colorsDarkMode(this.chartColors);
      this.service.legendDarkMode(this.chartLegend);
      this.service.seriesDarkMode(this.chartSeries);
    }
    this.bcacIsDarkMode = isdarkMode
  }

  @Input()
  set bcacSmallMode(smallMode: boolean | string) {
    const issmallMode: boolean = typeof (smallMode) == "string"
      ? JSON.parse(smallMode)
      : smallMode;
    if (issmallMode) {
      this.service.setSmallModeGrid(this.chartGrid);
    }
  }

  legendPosition = "top";
  @Input()
  set bcacLegendPosition(legendPosition: string) {
    this.legendPosition = legendPosition;
    this.service.setLegendPosition(this.chartGrid, this.chartLegend, legendPosition);
  }

  //todo  关闭标题栏
  @Input()
  set bcacTitleSwitch(titleSwitch: boolean | string) {
    this.chartTitle.show = typeof (titleSwitch) == "string"
      ? JSON.parse(titleSwitch)
      : titleSwitch;
  }

  @Input()
  set bcacTitle(title: string) {
    this.chartTitle.label = title;
  }

  @Input()
  set bcacXaxisName(xAxisname: string) {
    this.service.setXaxisName(this.chartxAxis, xAxisname);
  }
  @Input()
  set bcacYaxisName(yAxisNames: string) {
    this.chartOption.yAxis[0].name = yAxisNames
  }

  @Input()
  set bcacYnameGap(yNameGap: number) {
    this.service.setYnameGap(this.chartyAxis, yNameGap);
  }

  @Input()
  set bcacColors(colorList: string[]) {
    this.service.chartColorsChange(this.chartColors, colorList);
  }

  //todo x轴刻度标签旋转
  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate: number) {
    this.chartOption.xAxis[0].axisLabel.rotate = xAxisLabelRotate;
  }
  //todo  y轴刻度标签旋转
  @Input()
  set bcacYAxisLabelRotate(yAxisLabelRotate: number) {
    this.chartOption.yAxis[0].axisLabel.rotate = yAxisLabelRotate;
  }
  //todo tooltip显示格式化
  @Input()
  set bcacTooltipFormatter(value: any) {
    this.chartOption.tooltip = this.service.setTooltipFormat(value);
  }



  legendDataList;
  @Input()
  set bcacChartData(chartData: any) {
    if (chartData
      && chartData.xAxisDatas
      && Array.isArray(chartData.xAxisDatas)
      && chartData.seriesDatas
      && Array.isArray(chartData.seriesDatas)
    ) {

      this.chartOption.xAxis[0].data = chartData.xAxisDatas
      if (chartData.xFormatter) {
        this.chartOption.xAxis[0].axisLabel.formatter = chartData.xFormatter
      }
      if (chartData.xInterval) {
        this.chartOption.xAxis[0].axisLabel.interval = chartData.xInterval
      }
      let ydata = []
      this.legendDataList = []
      for (const item of chartData.seriesDatas) {
        ydata.push({
          name: item.name,
          data: item.data,
          type: 'line',
          smooth: true,
        })
        this.legendDataList.push({
          label: item.name,
          value: item.name,
          checked: true
        })
      }
      this.legendDataList = this.remove_duplicate(this.legendDataList)
      this.chartOption.series = ydata
    }
  }

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    if (!_.isNil(value)) {
      this.dataSourceSelectData = value;
    }

  }

  intervalDatas = [];
  @Input()
  set bcacInterValDatas(value: any[]) {
    if (!_.isNil(value)) {
      this.intervalDatas = value;
    }
  }

  // 加载等待
  _bcacChartLoading: boolean = false
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }


  @Output() bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }

  @Output() bcacGetChartInstance: EventEmitter<ECharts> = new EventEmitter<ECharts>();
  optionInstance;
  onOptionInit(ec) {
    this.optionInstance = ec;
    this.bcacGetChartInstance.emit(ec)
    this.zoomMonitor(); //todo
  }


  updateOption() {
    if (this.optionInstance) {
      this.optionInstance.setOption(this.chartOption, true);
    }
  }

  //todo 去重
  remove_duplicate(oldlist) {
    let newlist = {};
    return oldlist.reduce((p, c) => {
      newlist[c.value] ? '' : newlist[c.value] = true && p.push(c);
      return p
    }, []);
  }

  legendChange(e) {
    this.service.topLegendChange(e, this.optionInstance);
  }





  //todo 区域缩放
  zoomHistory = []
  isBackActive: boolean = false
  areaZoom(e) {
    this.service.zoomTrigger(e, this.optionInstance, this.zoomHistory);
    this.isBackActive = this.zoomHistory.length ? true : false
  }

  zoomMonitor() {
    if (this.optionInstance) {
      this.optionInstance.on('datazoom', (value) => {
        if (value.batch) {
          this.zoomHistory.push(value)
        }
        this.isBackActive = this.zoomHistory.length ? true : false
        this.cdr.detectChanges();
      });
    }
  }


  // X轴刻度间隔
  axisScaleChange(e: number) {
    if (this.optionInstance) {
      let option = this.optionInstance.getOption()
      option.xAxis[0].axisLabel.interval = e
      this.optionInstance.setOption(option, true)
    }
  }



  ngOnInit() {
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdapt(this.optionInstance, this.chartOption);
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateOption()
  }

}
